<template>
  <div>
    <a
      href="https://app.zeplin.io/project/5f092773fa16ac9ddd3d2a2f/screen/5f0d0f43402f527e308cf0d3"
      >Navigation</a
    >

    <h3>SideMenu</h3>
    <span>already show at left side</span>

    <h3>Segmental Controls</h3>

    <SegmentalControls
      class="mr-2"
      :buttons="['btnA', 'btnB']"
      v-model="btnValue"
      itemStyle="style-basic"
    ></SegmentalControls>
    <SegmentalControls itemStyle="style-primary"></SegmentalControls>

    <h3>Pagination</h3>
    <h3>Stepper</h3>
    <h3>Tab with badge</h3>
  </div>
</template>

<script>
import SegmentalControls from '@/components/SegmentalControls.vue';

export default {
  components: {
    SegmentalControls,
  },
  data: () => ({
    btnValue: 'btnB',
  }),
};
</script>

<style lang="scss">
.segmental-control {
  display: inline-flex;
  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 88px;
    height: 40px;
    cursor: pointer;

    &.style-basic {
      box-shadow: 0 1px 2px 0 rgba(4, 48, 71, 0.06),
        0 0 1px 0 rgba(4, 48, 71, 0.1);
      border: solid 0.5px #d7dee7;
      border-left-style: none;
      background-color: #ffffff;

      &:first-of-type {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        border: solid 0.5px #d7dee7;
      }

      &:last-of-type {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        border-left-style: none;
      }

      &.active {
        box-shadow: inset 0 1px 8px 0 rgba(0, 0, 0, 0.1),
          inset 0 1px 1px 0 rgba(0, 0, 0, 0.1);
        background-color: #f5f7f8;
      }
    }

    &.style-primary {
      font-size: 14px;
      color: #194cc3;
      box-shadow: 0 1px 2px 0 rgba(4, 48, 71, 0.06),
        0 0 1px 0 rgba(4, 48, 71, 0.1);
      border: solid 1px #194cc3;
      border-left-style: none;
      background-color: #ffffff;

      &:first-of-type {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        border: solid 1px #194cc3;
      }
      &:last-of-type {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        border-left-style: none;
      }
      &.active {
        color: white;
        box-shadow: 0 1px 2px 0 rgba(4, 48, 71, 0.06),
          0 0 1px 0 rgba(4, 48, 71, 0.1);
        background-color: #1e50c0;
      }
    }
  }
}
</style>
